function WarningPopup({ open, countdown, onConfirm }) {
  if (!open) return null

  return (
    <div
      style={{
        display: 'block',
        position: 'fixed',
        top: '20px',
        right: '20px',
        width: '300px',
        backgroundColor: 'orange',
        color: 'white',
        padding: '10px',
        borderRadius: '5px',
        zIndex: 1000
      }}
    >
      <p>
        You've been idle for a while. You will be logged out in {countdown} seconds if no action is
        taken. Touch or click anywhere to continue.
      </p>
    </div>
  )
}

export default WarningPopup
